/* ==========================================================================
   Mondō London — Saved (wishlist) + Share
   localStorage-backed, no account. Saved page: framed cards rendered with
   safe DOM methods, commerce and availability re-checked from the rendered
   product record (≤6 concurrent; 404 → pruned), quiet Add to bag, remove
   focus-handoff.
   ========================================================================== */
(function () {
  'use strict';
  var KEY = 'mondo:saved';
  var SAVED_SCHEMA_VERSION = 1;
  var CART_CHANGE_KEY = 'mondo:cart-change';
  var storageOk = true;
  try { localStorage.setItem('mondo:probe', '1'); localStorage.removeItem('mondo:probe'); }
  catch (e) { storageOk = false; }

  function shopEndpoint(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root : '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + String(path || '').replace(/^\/+/, '');
  }

  function signalCartChange() {
    if (!storageOk) return;
    try {
      localStorage.setItem(CART_CHANGE_KEY, String(Date.now()) + ':' + String(Math.random()));
    } catch (e) {}
  }

  function read() {
    if (!storageOk) return [];
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      if (Array.isArray(v)) return v;
      if (v && v.v === SAVED_SCHEMA_VERSION && Array.isArray(v.items)) return v.items;
      return [];
    }
    catch (e) { return []; }
  }
  function write(list) {
    if (storageOk) try { localStorage.setItem(KEY, JSON.stringify({ v: SAVED_SCHEMA_VERSION, items: list })); } catch (e) {}
  }
  function idOf(x) { return String(x && x.id != null ? x.id : x); }
  function has(list, id) { return list.some(function (x) { return idOf(x) === String(id); }); }
  function isArchiveSaved(x) { return Boolean(x && (x.archive === true || x.archive === 'true')); }
  function isCommerceProhibitedSaved(x) {
    return Boolean(x && (x.commerceProhibited === true || x.commerceProhibited === 'true' || isArchiveSaved(x)));
  }

  function savedImageSources(value, fallback) {
    var sources = [];
    if (Array.isArray(value)) sources = value.slice();
    else if (typeof value === 'string' && value) {
      try {
        var parsed = JSON.parse(value);
        if (Array.isArray(parsed)) sources = parsed;
      } catch (e) {}
    }
    if (fallback) sources.unshift(fallback);
    return sources.filter(function (source, index, all) {
      return typeof source === 'string' && source.length > 0 && all.indexOf(source) === index;
    });
  }

  function readWishlistImages(marker) {
    if (!marker) return [];
    return savedImageSources(
      marker.getAttribute('data-wishlist-images'),
      marker.getAttribute('data-image')
    );
  }

  function readCommerceRecord(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var marker = doc.querySelector('[data-wishlist-toggle][data-commerce-prohibited]');
    if (!marker) throw new Error('Missing commerce marker');
    return {
      archive: marker.getAttribute('data-archive') === 'true',
      state: marker.getAttribute('data-commerce-state') || 'unavailable',
      images: readWishlistImages(marker),
      prohibited: marker.getAttribute('data-commerce-prohibited') === 'true',
      variantId: marker.getAttribute('data-available-variant-id') || '',
      price: marker.getAttribute('data-price') || '',
      title: marker.getAttribute('data-title') || '',
      url: marker.getAttribute('data-url') || '',
      vendor: marker.getAttribute('data-vendor') || ''
    };
  }

  function disableSavedAdd(cell) {
    if (!cell) return;
    var add = cell.querySelector('[data-sv-add]');
    if (add) add.remove();
    var actions = cell.querySelector('.saved-acts');
    if (actions) actions.classList.add('saved-acts--single');
  }

  function enableSavedAdd(cell, handle, label) {
    if (!cell || cell.querySelector('[data-sv-add]')) return;
    var actions = cell.querySelector('.saved-acts');
    var remove = actions && actions.querySelector('[data-wishlist-remove]');
    if (!actions || !remove) return;
    var add = el('button', 'sv-add');
    add.type = 'button';
    add.appendChild(el('em', null, label));
    add.setAttribute('data-sv-add', handle || '');
    actions.insertBefore(add, remove);
    actions.classList.remove('saved-acts--single');
  }

  function updateCount() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n > 0 ? ' (' + n + ')' : '';
    });
    var sup = document.querySelector('[data-saved-count]');
    if (sup) { sup.textContent = '(' + n + ')'; sup.hidden = n === 0; }
  }

  function syncButtons() {
    var list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
      var saved = has(list, b.getAttribute('data-id'));
      b.classList.toggle('is-saved', saved);
      b.setAttribute('aria-pressed', saved ? 'true' : 'false');
      var lab = b.querySelector('.save-label');
      if (lab) lab.textContent = saved ? (b.getAttribute('data-l-saved') || 'Saved') : (b.getAttribute('data-l-save') || 'Save');
    });
  }

  function toggle(b) {
    var list = read();
    var id = b.getAttribute('data-id');
    if (has(list, id)) list = list.filter(function (x) { return idOf(x) !== String(id); });
    else list.push({
      id: id, handle: b.getAttribute('data-handle'), url: b.getAttribute('data-url'),
      title: b.getAttribute('data-title'), vendor: b.getAttribute('data-vendor'),
      price: b.getAttribute('data-price'), image: b.getAttribute('data-image'),
      images: savedImageSources(b.getAttribute('data-wishlist-images'), b.getAttribute('data-image')),
      archive: b.getAttribute('data-archive') === 'true',
      commerceState: b.getAttribute('data-commerce-state') || 'unavailable',
      commerceProhibited: b.getAttribute('data-commerce-prohibited') === 'true'
    });
    write(list); refresh();
  }

  /* ── the Saved page ────────────────────────────────────────────────── */
  var grid = document.querySelector('[data-wishlist-grid]');
  var loading = document.querySelector('[data-wishlist-loading]');
  var status = document.querySelector('[data-saved-status]');
  var arrowTemplate = document.querySelector('template[data-saved-arrow]');
  var renderVersion = 0;
  var savedCartQueue = Promise.resolve();

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function setLoading(busy) {
    if (loading) loading.hidden = !busy;
    if (grid) grid.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function setStatus(message) {
    if (status) status.textContent = message || '';
  }

  function gridLabel(name, fallback) {
    return grid && grid.getAttribute('data-l-' + name) || fallback;
  }

  function validCart(cart) {
    return Boolean(
      cart &&
      Array.isArray(cart.items) &&
      typeof cart.item_count === 'number'
    );
  }

  function cartHasVariant(cart, variantId) {
    return validCart(cart) && cart.items.some(function (item) {
      return item && String(item.variant_id) === String(variantId);
    });
  }

  function updateCartCount(cart) {
    try {
      document.querySelectorAll('[data-cart-count]').forEach(function (count) {
        count.textContent = cart.item_count > 0 ? ' (' + cart.item_count + ')' : '';
      });
      return true;
    } catch (e) {
      return false;
    }
  }

  function confirmSavedAdd(button, cart) {
    var label = button.querySelector('em');
    if (label) label.textContent = gridLabel('in-bag', 'In your bag');
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    var countUpdated = updateCartCount(cart);
    setStatus(countUpdated
      ? gridLabel('in-bag', 'In your bag.')
      : gridLabel('count-stale', 'This piece is in your bag, but the bag count could not refresh.'));
    signalCartChange();
  }

  function resetSavedAdd(button) {
    button.disabled = false;
    button.removeAttribute('aria-disabled');
    setStatus(gridLabel('add-error', 'This piece could not be added to your bag. Try again.'));
  }

  function fetchCanonicalCart() {
    return fetch(shopEndpoint('cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .then(function (cart) {
        if (!validCart(cart)) throw new Error('Invalid cart response');
        return cart;
      });
  }

  function enqueueSavedCart(work) {
    var run = savedCartQueue.catch(function () {}).then(work);
    savedCartQueue = run.catch(function () {});
    return run;
  }

  function mutateSavedVariant(variantId) {
    return enqueueSavedCart(function () {
      var updates = {};
      updates[String(variantId)] = 1;

      return fetch(shopEndpoint('cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (response) {
        if (!response.ok) throw new Error('Add to bag failed');
        return response.json();
      }).then(function (cart) {
        if (!cartHasVariant(cart, variantId)) {
          throw new Error('Added variant missing from cart response');
        }
        return { cart: cart, present: true };
      }).catch(function () {
        // The write may have committed despite an error or lost response. Keep
        // this read in the same queue so a later add cannot overtake recovery.
        return fetchCanonicalCart().then(function (cart) {
          return { cart: cart, present: cartHasVariant(cart, variantId) };
        }, function () {
          return { cart: null, present: false };
        });
      });
    });
  }

  function appendSavedArrow(parent) {
    if (!arrowTemplate || !arrowTemplate.content) return;
    var arrow = arrowTemplate.content.querySelector('svg');
    if (arrow) parent.appendChild(arrow.cloneNode(true));
  }

  function setSavedAlternate(preview, source) {
    var current = preview.querySelector('.alt-img');
    if (current) current.remove();
    preview.removeAttribute('data-card-preview');
    if (!source) return;

    var alternate = document.createElement('img');
    alternate.className = 'alt-img';
    alternate.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
    alternate.setAttribute('data-src', source);
    alternate.alt = '';
    alternate.loading = 'lazy';
    alternate.width = 540;
    alternate.height = 720;
    preview.appendChild(alternate);
    preview.setAttribute('data-card-preview', '');
  }

  function applySavedImages(cell, value) {
    var sources = savedImageSources(value);
    if (!cell || !sources.length) return;
    var preview = cell.querySelector('.ph');
    var image = preview && preview.querySelector('.card-gallery__primary img');
    if (!preview || !image) return;

    if (preview._cardPreviewTimer) clearTimeout(preview._cardPreviewTimer);
    preview._cardPreviewTimer = 0;
    preview._cardPreviewLoading = false;
    preview._cardPreviewToken = (preview._cardPreviewToken || 0) + 1;
    preview.classList.remove('is-previewing');
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.setAttribute('src', sources[0]);
    setSavedAlternate(preview, sources[1]);
  }

  function savedImageAlt(x) {
    return (x.vendor || '') + ' ' + (x.title || '') + '. Mondō London.';
  }

  function applySavedIdentity(cell, x, removeLabel) {
    var title = cell.querySelector('.cbar-t');
    if (title) title.textContent = x.title || '';
    var link = cell.querySelector('.card-link');
    if (link) link.href = x.url || '#';
    var image = cell.querySelector('.card-gallery__primary img');
    if (image) image.alt = savedImageAlt(x);
    var remove = cell.querySelector('[data-wishlist-remove]');
    if (remove) remove.setAttribute('aria-label', removeLabel + ' - ' + (x.title || ''));
  }

  function buildCard(x, L) {
    var cell = el('article', 'card'); cell.setAttribute('data-card', ''); cell.setAttribute('data-sid', idOf(x));
    var link = el('a', 'card-link'); link.href = x.url || '#';
    var ph = el('div', 'ph');
    var images = savedImageSources(x.images, x.image);
    if (images.length) {
      var imageFrame = el('span', 'card-gallery__primary');
      var img = document.createElement('img');
      img.src = images[0]; img.alt = savedImageAlt(x);
      img.loading = 'lazy'; img.width = 540; img.height = 720;
      imageFrame.appendChild(img);
      ph.appendChild(imageFrame);
      setSavedAlternate(ph, images[1]);
    }
    link.appendChild(ph);
    var cbar = el('div', 'cbar');
    cbar.appendChild(el('span', 'cbar-t', x.title || ''));
    var cbarRow = el('span', 'cbar-row');
    var archived = isArchiveSaved(x);
    var commerceProhibited = isCommerceProhibitedSaved(x);
    var initialStatus = x.commerceState === 'sold' ? L.sold
      : x.commerceState === 'market_unavailable' ? L.marketUnavailable
        : commerceProhibited ? (archived ? L.archive : L.unavailable) : L.checking;
    var price = el('span', 'cbar-sold', initialStatus); price.setAttribute('data-sprice', '');
    cbarRow.appendChild(price);
    appendSavedArrow(cbarRow);
    cbar.appendChild(cbarRow);
    link.appendChild(cbar);
    cell.appendChild(link);
    var acts = el('div', 'saved-acts');
    if (!commerceProhibited) {
      var add = el('button', 'sv-add'); add.type = 'button';
      add.appendChild(el('em', null, L.add)); add.setAttribute('data-sv-add', x.handle || '');
      acts.appendChild(add);
    } else {
      acts.classList.add('saved-acts--single');
    }
    var rm = el('button', 'wl-remove'); rm.type = 'button';
    rm.setAttribute('data-wishlist-remove', ''); rm.setAttribute('data-id', idOf(x));
    rm.setAttribute('aria-label', L.remove + ' - ' + (x.title || ''));
    rm.appendChild(el('em', null, L.remove));
    acts.appendChild(rm);
    cell.appendChild(acts);
    return cell;
  }

  function renderPage() {
    if (!grid) return;
    var version = ++renderVersion;
    var L = {
      remove: grid.getAttribute('data-l-remove') || 'Remove',
      add: grid.getAttribute('data-l-add') || 'Add to bag',
      inBag: grid.getAttribute('data-l-in-bag') || 'In your bag',
      sold: grid.getAttribute('data-l-sold') || 'Sold',
      marketUnavailable: grid.getAttribute('data-l-market-unavailable') || 'Unavailable in your region',
      archive: grid.getAttribute('data-l-archive') || 'Archive piece',
      unavailable: grid.getAttribute('data-l-unavailable') || 'Not for sale',
      checking: grid.getAttribute('data-l-checking') || 'Checking availability.'
    };
    var blockedMsg = document.querySelector('[data-storage-blocked]');
    if (blockedMsg) blockedMsg.hidden = storageOk;
    var list = read();
    var empty = document.querySelector('[data-wishlist-empty]');
    var foot = document.querySelector('[data-saved-foot]');
    grid.textContent = '';
    if (!list.length) {
      setLoading(false);
      setStatus(storageOk ? '' : gridLabel('storage-blocked', 'Saving is unavailable in this browser.'));
      if (empty) empty.hidden = false;
      if (foot) foot.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (foot) foot.hidden = false;
    list.forEach(function (x) { grid.appendChild(buildCard(x, L)); });
    recheck(list, L, version);
  }

  function recheck(list, L, version) {
    var queue = list.slice();
    var active = 0;
    var failures = 0;

    setLoading(false);
    if (grid) grid.setAttribute('aria-busy', 'true');
    setStatus(L.checking);

    function finishIfReady() {
      if (version !== renderVersion || queue.length || active) return;
      if (grid) grid.setAttribute('aria-busy', 'false');
      setStatus(failures
        ? gridLabel('availability-partial', 'Some saved-piece availability could not be confirmed. Please try again later.')
        : gridLabel('availability-ok', 'Saved-piece availability is up to date.'));
    }

    function checkOne(x) {
      var handle = x && x.handle;
      var request = handle
        ? fetch(shopEndpoint('products/' + encodeURIComponent(handle)), { headers: { Accept: 'text/html' } })
        : Promise.reject(new Error('Missing product handle'));

      request
        .then(function (r) {
          if (version !== renderVersion) return null;
          if (r.status === 404) { prune(idOf(x)); return null; }
          if (!r.ok) throw new Error('Availability request failed');
          return r.text();
        })
        .then(function (html) {
          if (version !== renderVersion || !html) return;
          var cell = grid.querySelector('[data-sid="' + idOf(x) + '"]');
          if (!cell) return;
          var record = readCommerceRecord(html);
          x.archive = record.archive;
          x.commerceState = record.state;
          x.commerceProhibited = record.prohibited;
          if (record.price) x.price = record.price;
          if (record.title) x.title = record.title;
          if (record.url) x.url = record.url;
          if (record.vendor) x.vendor = record.vendor;
          applySavedImages(cell, record.images);
          if (record.images.length) {
            x.image = record.images[0];
            x.images = record.images;
          }
          write(list);
          applySavedIdentity(cell, x, L.remove);
          var price = cell.querySelector('[data-sprice]');
          if (record.variantId && !record.prohibited) {
            if (price) {
              price.className = 'cbar-p';
              price.textContent = x.price || '';
            }
            enableSavedAdd(cell, handle, L.add);
            return;
          }
          if (price) {
            price.className = 'cbar-sold';
            price.textContent = record.state === 'market_unavailable' ? L.marketUnavailable
              : record.state === 'sold' ? L.sold
                : record.archive ? L.archive : L.unavailable;
          }
          disableSavedAdd(cell);
        })
        .catch(function () {
          if (version === renderVersion) {
            failures++;
            disableSavedAdd(grid.querySelector('[data-sid="' + idOf(x) + '"]'));
          }
        })
        .then(function () {
          if (version !== renderVersion) return;
          active--;
          next();
          finishIfReady();
        });
    }

    function next() {
      if (version !== renderVersion) return;
      while (queue.length && active < 6) {
        active++;
        checkOne(queue.shift());
      }
      finishIfReady();
    }
    next();
  }

  function prune(id) {
    write(read().filter(function (x) { return idOf(x) !== String(id); }));
    refresh();
  }

  function removeWithFocus(btn) {
    var id = btn.getAttribute('data-id');
    var rms = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-wishlist-remove]')) : [];
    var idx = rms.indexOf(btn);
    write(read().filter(function (x) { return idOf(x) !== String(id); }));
    refresh();
    var remaining = grid ? grid.querySelectorAll('[data-wishlist-remove]') : [];
    var target = remaining[idx] || remaining[idx - 1];
    if (target) target.focus();
    else {
      var emptyFocus = document.querySelector('[data-saved-empty-focus]');
      if (emptyFocus) emptyFocus.focus();
    }
  }

  function refresh() { syncButtons(); updateCount(); renderPage(); }

  /* ── share (unchanged) ─────────────────────────────────────────────── */
  function share(btn) {
    var url = btn.getAttribute('data-share-url') || location.href;
    var title = btn.getAttribute('data-share-title') || document.title;
    if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () { flash(btn); }).catch(function () { window.prompt('Copy link', url); });
      return;
    }
    window.prompt('Copy link', url);
  }
  function flash(btn) {
    var lab = btn.querySelector('.share-label');
    if (!lab) return;
    var orig = btn.getAttribute('data-l-share') || lab.textContent;
    var copied = btn.getAttribute('data-l-copied') || 'Link copied';
    var shareStatus = btn.querySelector('[data-share-status]');
    lab.textContent = copied;
    if (shareStatus) shareStatus.textContent = copied;
    setTimeout(function () {
      lab.textContent = orig;
      if (shareStatus) shareStatus.textContent = '';
    }, 1600);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-wishlist-toggle],[data-wishlist-remove],[data-share],[data-sv-add]') : null;
    if (!t) return;
    if (t.hasAttribute('data-sv-add')) {
      e.preventDefault();
      var handle = t.getAttribute('data-sv-add');
      t.disabled = true;
      setStatus(gridLabel('adding', 'Adding this piece to your bag.'));
      var confirmedUnavailable = false;
      var mutationStarted = false;
      var variantId = '';
      var productRequest = handle
        ? fetch(shopEndpoint('products/' + encodeURIComponent(handle)), { headers: { Accept: 'text/html' } })
        : Promise.reject(new Error('Missing product handle'));
      productRequest.then(function (r) {
        if (!r.ok) throw new Error('Product request failed');
        return r.text();
      }).then(function (html) {
        var record = readCommerceRecord(html);
        if (record.prohibited || !record.variantId) {
          confirmedUnavailable = true;
          throw new Error('Product is not available to purchase');
        }
        variantId = String(record.variantId);
        mutationStarted = true;
        return mutateSavedVariant(variantId);
      }).then(function (result) {
        if (result.present) {
          confirmSavedAdd(t, result.cart);
        } else {
          // A transform may have replaced the requested variant, or the write
          // may still be ambiguous. Other tabs must reconcile either outcome.
          if (result.cart) updateCartCount(result.cart);
          signalCartChange();
          resetSavedAdd(t);
        }
      }).catch(function () {
        if (!mutationStarted) {
          if (confirmedUnavailable) disableSavedAdd(t.closest('[data-card]'));
          else t.disabled = false;
          if (confirmedUnavailable) {
            setStatus(gridLabel('add-error', 'This piece could not be added to your bag. Try again.'));
          } else resetSavedAdd(t);
          return;
        }

        signalCartChange();
        resetSavedAdd(t);
      });
      return;
    }
    e.preventDefault();
    if (t.hasAttribute('data-share')) share(t);
    else if (t.hasAttribute('data-wishlist-remove')) removeWithFocus(t);
    else toggle(t);
  });

  window.addEventListener('storage', function (e) { if (e.key === KEY) refresh(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
})();
